// Shared registry for mobile action-button sub-labels. Game logic
// updates these slots whenever the contextual action changes (interact
// prompt swaps, ult cools, mythic picked up). The touch UI reads them
// each frame and renders them inside the desktop-key-style button.
//
// Why a registry vs. events: subscriber count is exactly 1 (the touch
// HUD), and the touch HUD already runs a rAF loop for haptic timing.
// Polling these strings is cheaper than an event roundtrip and keeps
// app.ts → touch.ts one-way.

export type TouchKeyLabels = {
  // E button: primary contextual action — "HOOD", "USE BED", "HEAL", null.
  e: string | null;
  // Q button: ult state — "ULT" when chargeable, "AIM" mid-leap, null when
  // unavailable (locked / not unlocked). Button stays visible even when
  // the label is null so the player always sees the cooldown ring.
  q: string | null;
  // qCharge: 0..1 fill of the ring around the Q button. 1 = ready to
  // press (full ring), 0 = freshly used (empty ring), in-between = mid-
  // recharge. null = no charge data available (lobby / no match), the
  // ring renders dim/disabled.
  qCharge: number | null;
  // R button: mythic name when owned ("DEATH NOTE", "GO VIRAL"), null
  // otherwise (button hidden).
  r: string | null;
};

const labels: TouchKeyLabels = { e: null, q: null, qCharge: null, r: null };

export function setTouchLabel<K extends keyof TouchKeyLabels>(
  key: K,
  value: TouchKeyLabels[K],
): void {
  labels[key] = value;
}

export function getTouchLabels(): Readonly<TouchKeyLabels> {
  return labels;
}
